import { EditOutlined, FileTextOutlined } from "@ant-design/icons";
import { Avatar, Button, Tooltip } from "antd";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import noImage from "../../../src/assets/no-image.avif";
import { formatTime } from "../../utils/formatTime";
import { checkImageSource } from "../../utils/Utils";
import { LuAlarmClock } from "react-icons/lu";

const fileStore = process.env.REACT_APP_FILE_STORE || "http://10.1.1.230:8300";

const DraftMessageComponent = ({
  draftMessage,
  languageMap,
  selectedConversation,
  setIsReply,
  isReplyAll,
}) => {
  const [isOpenOut, setIsOpenOut] = useState(false);
  const [processedContent, setProcessedContent] = useState("");

  const changeOpenUp = () => {
    setIsOpenOut(!isOpenOut);
  };

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();

      img.onload = () => {
        resolve(true);
      };

      img.onerror = () => {
        resolve(false);
      };

      img.src = url;
    });
  };

  const showOpenDownArrow = () => {
    return (
      <button
        onClick={changeOpenUp}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        className="cursor-pointer"
      >
        {isOpenOut ? (
          <Tooltip
            placement="top"
            title={languageMap?.["modal.message.showLess"] ?? "show less"}
            color={"#0091ff"}
          >
            <IoMdArrowDropdown size={20} color="black" />
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            title={languageMap?.["modal.message.showMore"] ?? "show more"}
            color={"#0091ff"}
          >
            <IoMdArrowDropright size={20} color="black" />
          </Tooltip>
        )}
      </button>
    );
  };

  useEffect(() => {
    const processImages = async () => {
      const content = draftMessage?.content;

      if (!content) return;

      const doc = new DOMParser().parseFromString(content, "text/html");
      const imagePromises = Array.from(doc.querySelectorAll("img")).map(
        async (imgDoc) => {
          if (imgDoc?.src) {
            const imageType = checkImageSource(imgDoc.src);

            if (imageType === "INVALID") {
              imgDoc.remove();
              return;
            }

            const start = imgDoc.src.indexOf("/store/");
            const end = imgDoc.src.indexOf("?");
            const newSrcImg =
              end !== -1
                ? imgDoc.src.slice(start, end)
                : imgDoc.src.slice(start);

            const newUrlImage = `${fileStore}/conversation/${selectedConversation?.conversationId}${newSrcImg}?token=${Cookies.get("access_token")}`;

            const exists = await checkImageExists(newUrlImage);
            if (exists) {
              imgDoc.src = newUrlImage;
            } else {
              imgDoc.src = noImage;
              imgDoc.style.height = `120px`;
              imgDoc.style.width = `auto`;
            }
          }
        },
      );

      await Promise.all(imagePromises);
      setProcessedContent(doc.body.innerHTML);
    };

    processImages();
  }, [draftMessage?.notificationId, draftMessage?.content]);

  return (
    <div className={`bg-white rounded-lg p-1 mt-2`}>
      <button className="flex justify-between bg-[#e3f0fc] rounded w-[100%]">
        <div className="flex items-center gap-[6px] mb-2 mt-2 ml-1">
          <Avatar
            size={32}
            className={`${draftMessage?.triggerId ? "bg-[#2a56b9]" : "bg-[#0B6478]"}`}
            icon={
              draftMessage?.triggerId ? <LuAlarmClock /> : <FileTextOutlined />
            }
          />
          <div className="mr-2">
            <div className="text-[14px] flex items-center">
              <div className="font-bold">
                {draftMessage?.triggerId
                  ? `Scheduled at ${formatTime(draftMessage?.scheduleTime)}`
                  : `Draft saved at ${formatTime(draftMessage?.updatedAt)}`}
              </div>
              <div className="ml-2">
                <Button
                  type="text"
                  icon={<EditOutlined />}
                  onClick={() => setIsReply(true)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-[10px]">
          <div className="text-[#5e5e5e] justify-end items-end"></div>
        </div>
      </button>
    </div>
  );
};
export { DraftMessageComponent };
